module.exports = __webpack_public_path__ + "static/media/newRegisterTile.990b8fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/newRegisterTile.png
// module id = 1506
// module chunks = 0